import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import '../assets/css/style.css'
import '../assets/css/error.css'
import { useNavigate } from 'react-router-dom'

export default function Error() {
    
    const nav = useNavigate();

    function navigator(){
        nav('/');
    }

  return (
    <div className='ErrorBody'>
      <Navbar/>
      <div className='ContentInError'>
        <div className='HeadingError'><h1>Error 404</h1></div>
        <div className='ContentError'><p>The page you are looking for doesn't exist. It may have been moved or removed altogether. Please try searching for some other page, or return to the website's homepage to find what you're looking for.</p></div>
        <div className='ErrorButton'>
            <button onClick={navigator}>BACK TO HOME</button>
        </div>
      </div>
      <Footer/>
    </div>
  )
}
